'use strict';
/**
 * Author:fanglijuan
 *
 * Time:2019-05-05
 */
angular.module('quickSignOneClickQuickSignDetailListModule', []).
directive('oneClickQuickSignDetailList', ["$q", "$timeout", "$state", "trsHttpService", "modalDialog", "$stateParams", "trsspliceString", "appQuickSignService",
    function($q, $timeout, $state, trsHttpService, modalDialog, $stateParams, trsspliceString, appQuickSignService) {
        return {
            scope: {
                callback: "&",
                itemInfo: "=",
                ismine: "=", //是否我的
            },
            replace: true,
            restrict: 'E',
            templateUrl: './editingCenter/app/quickSign/oneClickQuickSign/oneClickQuickSignDetailList/oneClickQuickSignDetailList_tpl.html',
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                /**
                 * [initStatus description]初始化页面参数
                 * @return {[type]} [description]null
                 */
                function initStatus() {
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 10,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 1,
                    };
                    $scope.data = {
                        lists: [],
                        selectedArray: [],
                    };
                    $scope.status = {
                        relType: 1, //默认稿件:1稿件;2推送
                        keywords: '',
                        copyCurrPage: 1,
                        fromOptions: [], //来源类型
                        fromSelected: {},
                        docTypeOptions: [{ //0：全部；1：图文；2：音频；3：视频；4：活动；
                            name: "全部",
                            value: 0
                        }, {
                            name: "图文",
                            value: 1
                        }, {
                            name: "音频",
                            value: 2
                        }, {
                            name: "视频",
                            value: 3
                        }, {
                            name: "活动",
                            value: 4
                        }], // 稿件类型
                        docTypeSelected: { name: "全部", value: 0 },
                        indexName: '', //数据库名
                    };
                    $scope.params = {
                        typeid: "zyzx",
                        serviceid: "quickSign",
                        modelid: "docList",
                        pageNum: $scope.page.CURRPAGE,
                        pageSize: $scope.page.PAGESIZE,
                        keyword: $scope.status.keywords,
                    };
                }
                /**
                 * [initData description]初始化页面数据
                 * @return {[type]} [description]null
                 */
                function initData() {
                    getChannelPath();
                    getOriginDropData(); //来源下拉框数据
                }
                /**
                 * [getOriginDropData description]获取栏目路径（不包括站点名）
                 * @return {[type]} [description]
                 */
                function getChannelPath() {
                    var params = {
                        serviceid: "mlf_appconfig",
                        methodname: "getChannelPath",
                        channelId: $scope.itemInfo.CHANNELID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        $scope.status.chnlPath = data.PATH;
                    });
                }
                /**
                 * [getOriginDropData description]获取来源下拉数据 栏目下所有已关联的来源
                 * @return {[type]} [description]
                 */
                function getOriginDropData() {
                    var params = {
                        serviceid: "mlf_appquickpublish",
                        methodname: "queryRelByChannelId",
                        channelId: $scope.itemInfo.CHANNELID,
                        ismine: $scope.ismine,
                        relType: $scope.status.relType,
                        SITEID: $stateParams.siteid, //权限校验要用到siteid
                    };
                    $scope.status.fromOptions = [];
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        var ids = [];
                        for (var i = 0; i < data.length; i++) {
                            $scope.status.fromOptions.push({
                                name: data[i].CATEGORYNAME,
                                value: '{"' + data[i].CATEGORYID + '":"' + data[i].CATEGORYTYPE + '"}',
                            });
                            ids.push('"' + data[i].CATEGORYID + '":"' + data[i].CATEGORYTYPE + '"');
                        }
                        $scope.status.fromOptions.unshift({ name: "全部来源", value: '{' + ids.join() + '}' });
                        $scope.status.fromSelected = $scope.status.fromOptions[0];
                        $timeout(function() {
                            requestData();
                        });
                    });
                }
                /**
                 * [changeSource 切换来源回调]
                 * @return {[type]} [description]
                 */
                $scope.changeCallback = function() {
                    $scope.page.CURRPAGE = 1;
                    requestData();
                };
                $scope.showPageByRelType = function(type) {
                    $scope.status.relType = type;
                    $scope.page.CURRPAGE = $scope.status.copyCurrPage = 1;
                    $scope.data.lists = [];
                    $scope.data.selectedArray = [];
                    initParams();
                    getOriginDropData(); //来源也要重新获取
                };
                /**
                 * [requestData description] 获取数据
                 * @return {[type]} [description]
                 */
                function requestData() {
                    var defer = $q.defer();
                    var params = angular.copy($scope.params);

                    params.hybaseEntries = $scope.status.fromSelected.value;
                    params.chosenSource = $scope.status.docTypeSelected.value; // 类型
                    $scope.data.lists = [];
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                        if (data != "") {
                            $scope.data.selectedArray = [];
                            if (data.summary_info) {
                                $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                                $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                                $scope.page.CURRPAGE = params.pageNum;
                                if ($scope.status.relType == 2) {
                                    for (var i = 0; i < data.content.length; i++) {
                                        data.content[i].CONTENT = returnHtml(data.content[i].CONTENT);
                                    }
                                }
                                // 查询所有图片
                                if ($scope.status.relType == 1) {
                                    if (data.summary_info.guids == undefined) { //兼容无数据时,不返回guids的情况
                                        return;
                                    }
                                    if (data.summary_info.guids[data.summary_info.guids.length - 1] == ",") {
                                        data.summary_info.guids = data.summary_info.guids.slice(0, data.summary_info.guids.length - 1);
                                    }
                                    $scope.loadingPromise = getImgList(data.summary_info.guids).then(function(res) {
                                        var temp = res.content[0];
                                        for (var i = 0; i < data.content.length; i++) {
                                            if (!data.content[i].imgurl) {
                                                data.content[i].width = temp[data.content[i].GUID] && temp[data.content[i].GUID].IMAGEURLS[0].wight;
                                                data.content[i].height = temp[data.content[i].GUID] && temp[data.content[i].GUID].IMAGEURLS[0].height;
                                                data.content[i].imgurl = temp[data.content[i].GUID] && temp[data.content[i].GUID].IMAGEURLS;
                                            }
                                            data.content[i].sourceTypeName = getTypeNameById(data.content[i].SOURETYPE);
                                        }
                                        $timeout(function() {
                                            $scope.data.lists = data.content;
                                            initOperFlag();
                                            defer.resolve();
                                        });
                                    });
                                } else {
                                    $scope.data.lists = data.content;
                                    initOperFlag();
                                    defer.resolve();
                                }
                            }
                        }

                    });
                    return defer.promise;
                }

                function getTypeNameById(type) {
                    let typeName = '';
                    for (var i = 0; i < $scope.status.docTypeOptions.length; i++) {
                        if ($scope.status.docTypeOptions[i].value == type) {
                            typeName = $scope.status.docTypeOptions[i].name;
                        }
                    }
                    return typeName;
                }
                /**
                 * [getImgList description] 获取所有图
                 * @param  {[type]} guids [description]
                 * @return {[type]}       [description]
                 */
                function getImgList(guids) {
                    var defer = $q.defer();
                    var params = {
                        typeid: "zyzx",
                        serviceid: "iwo",
                        modelid: "getImgList",
                        channelName: 'iwo',
                        guids: guids
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(res) {
                        defer.resolve(res);
                    });
                    return defer.promise;
                }
                /**
                 * [initOperFlag description]初始化，获取列表已快签信息
                 * @return {[type]} [description]
                 */
                function initOperFlag() {
                    var docIds = trsspliceString.spliceString($scope.data.lists, "GUID", ",");
                    if (docIds) {
                        var params = {
                            methodname: "queryFlag",
                            serviceid: "mlf_appquickpublish",
                            GUIDS: docIds,
                            SITEID: $scope.itemInfo.SITEID, //站点id
                            CHANNELID: $scope.itemInfo.CHANNELID, //栏目id
                            reltype: $scope.status.reltype, //关联类型，1：稿件，2推送
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            $scope.data.qianFlags = [];
                            var temp = data;
                            for (var i in temp) {
                                if (angular.isDefined(temp[i])) {
                                    $scope.data.qianFlags[i] = temp[i];
                                }
                            }
                        });
                    }
                }
                /**
                 * [showFlag description]显示是否已快签
                 * @return {[type]} [description]
                 */
                $scope.showFlag = function(guid, item) {
                    var temp = queryItemBYGUID(guid, item);
                    if (!!temp) {
                        return true;
                    } else {
                        return false;
                    }
                };

                function queryItemBYGUID(guid, item) {
                    for (var i in $scope.data.qianFlags) {
                        if (guid == $scope.data.qianFlags[i].GUID) {
                            item.qianData = $scope.data.qianFlags[i];
                            return $scope.data.qianFlags[i];
                        }
                    }
                }
                /**
                 * [returnHtml description] 返回html 代码，去除 &nbsp; 等
                 * @param  {[type]} text [description]
                 * @return {[type]}      [description]
                 */
                $scope.returnHtml = function(text) {
                    if (!text || text == null || text == "NULL") return "";
                    text = text.replace(/&nbsp;/g, ' ').replace(/&amp;/g, "&").replace(/&quot;/g, '"');
                    return text;
                };

                function returnHtml(text) {
                    if (!text || text == null || text == "NULL") return "";
                    text = text.replace(/&nbsp;/g, ' ').replace(/&amp;/g, "&").replace(/&quot;/g, '"');
                    return text;
                }
                /**
                 * [fullTextSearch description;全文检索]
                 * @param  {[type]} ev [description:按下空格也能提交]
                 */
                $scope.fullTextSearch = function(ev) {
                    if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                        $scope.params.keyword = $scope.status.keywords;
                        $scope.page.CURRPAGE = 1;
                        requestData();
                    }
                };
                /**
                 * [selectAll description]全选列表
                 * @return {[type]} [description] null
                 */
                $scope.selectAll = function() {
                    $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.lists.length ? [] : [].concat($scope.data.lists);
                };
                /**
                 * [chooseItem description] 勾选
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.chooseItem = function(item) {
                    if ($scope.data.selectedArray.indexOf(item) < 0) {
                        $scope.data.selectedArray.push(item);
                    } else {
                        $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                    }
                };
                /**
                 * [pageChanged description]下一页
                 * @return {[type]} [description] null
                 */
                $scope.pageChanged = function() {
                    $scope.params.pageNum = $scope.page.CURRPAGE;
                    $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                    requestData();
                };
                //选择单页显示个数
                $scope.selectPageNum = function() {
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.params.pageNum = $scope.page.CURRPAGE;
                    $scope.status.copyCurrPage = 1;
                    requestData();
                };
                /**
                 * [jumpToPage description] 跳转到指定页面
                 * @return {[type]} [description]
                 */
                $scope.jumpToPage = function() {
                    if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                        $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                    }
                    if ($scope.status.copyCurrPage < 1) {
                        $scope.status.copyCurrPage = 1;
                    }
                    $scope.params.pageNum = $scope.status.copyCurrPage;
                    requestData();
                };

                //返回主列表页
                $scope.goBackMainList = function() {
                    $timeout(function() {
                        $scope.callback();
                    });
                };
                /**
                 * [directSign description] 直接快签
                 * @return {[type]} [description]
                 */
                $scope.directSign = function() {
                    modalDialog.confirmModal("选中稿件" + $scope.data.selectedArray.length + "项", "确定直接快签？", function() {
                        var jsonObj = {};
                        var indexNameArr = [];
                        for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                            jsonObj[$scope.data.selectedArray[i].GUID] = $scope.data.selectedArray[i].HYBASEID;
                            indexNameArr.push({ 'indexName': $scope.data.selectedArray[i].INDEXNAME });
                        }
                        indexNameArr = appQuickSignService.excludeRepeatFromArr(indexNameArr);
                        var params = {
                            serviceid: "mlf_appquickpublish",
                            methodname: "quickpub",
                            SITEID: $scope.itemInfo.SITEID, //站点id
                            CHANNELID: $scope.itemInfo.CHANNELID, //栏目id
                            CATEGORYID: JSON.stringify(jsonObj), //分类id
                            reltype: $scope.status.relType, //签发类型
                            indexName: trsspliceString.spliceString(indexNameArr, "indexName", ','), // $scope.status.indexName, //数据库名
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("直接快签成功", "", "success", false, function() {
                                initParams();
                                requestData();
                            });
                        }, function() {
                            requestData();
                        });
                    });
                };
                //还原:初始化部分参数
                function initParams() {
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 10,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 1,
                    };
                    $scope.params.pageNum = $scope.page.CURRPAGE = $scope.status.copyCurrPage = 1;
                    $scope.data.selectedArray = $scope.data.lists = [];
                }
                /**
                 * [timingSign description] 定时快签
                 * @return {[type]} [description]
                 */
                $scope.timingSign = function() {
                    appQuickSignService.timingSign($scope.data.selectedArray).then(function(timeData) {
                        var jsonObj = {};
                        var indexNameArr = [];
                        for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                            jsonObj[$scope.data.selectedArray[i].GUID] = $scope.data.selectedArray[i].HYBASEID;
                            indexNameArr.push({ 'indexName': $scope.data.selectedArray[i].INDEXNAME });
                        }
                        indexNameArr = appQuickSignService.excludeRepeatFromArr(indexNameArr);
                        var params = {
                            serviceid: "mlf_appquickpublish",
                            methodname: "timingQuickPub",
                            SITEID: $scope.itemInfo.SITEID, //站点id
                            CHANNELID: $scope.itemInfo.CHANNELID, //栏目id
                            CATEGORYID: JSON.stringify(jsonObj), //分类id
                            ScheduleTime: timeData,
                            reltype: $scope.status.relType,
                            indexName: trsspliceString.spliceString(indexNameArr, "indexName", ','), // $scope.status.indexName, //数据库名
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("定时快签成功", "", "success", false, function() {
                                initParams();
                                requestData();
                            });
                        }, function() {
                            requestData();
                        });
                    }, function() {

                    });
                };
                /**
                 * [listMapDetail description] 列表图 稿件详情弹窗
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.listMapDetail = function(item) {
                    appQuickSignService.listMapDetail(item, $scope.itemInfo, $scope.data.selectedArray).then(function(data) {
                        initParams();
                        requestData();
                    });
                };
                /**
                 * [editPushDetail description] 编辑推送详情弹窗
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.editPushDetail = function(item) {
                    appQuickSignService.editPushDetail(item, $scope.itemInfo, $scope.data.selectedArray).then(function(data) {
                        initParams();
                        requestData();
                    });
                };
                /**
                 * [goToResourceDetail description] 
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.goToResourceDetail = function(item) {
                    window.open("#/resourcedetail?guid=" + item.GUID + "&indexname=" + item.INDEXNAME);
                };
            }
        };
    }
]);